export const calculateMarketValue = (quantity, price) => {
  if (!price) return 0.0;
  return quantity * parseFloat(price);
};

export const formatCurrency = (value) => {
    if (value === null || value === undefined) return '-';

    const number = parseFloat(value); // Ensure it's a number
    if (isNaN(number)) return '-'; // Handle invalid input

    return number.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD', // You can change this to your desired currency
        minimumFractionDigits: 2, // Ensure two decimal places
        maximumFractionDigits: 2, // Ensure two decimal places
    });
};

export const formatDecimalPlaces = (value, decimalPlaces = 2) => {
  // Check for null or undefined input
  if (value === null || value === undefined) {
    return '-';
  }

  // Attempt to convert the input value to a floating-point number
  const number = parseFloat(value);

  // Check if the conversion resulted in NaN (Not-a-Number)
  if (isNaN(number)) {
    return '-'; // Return '-' if input wasn't a valid number
  }

  // Use the toFixed() method which rounds and formats the number
  // to the specified number of decimal places, returning a string.
  return number.toFixed(decimalPlaces);
};

export const getRowKey = (item) => {
  const position = item.position || '';
  const type = item.type || 'stock';
  const optionType = item.option_type || 'none';
  const strike = item.strike_price || 0;
  const expiry = item.expiration_date || 'na';

  return `${position}-${type}-${optionType}-${strike}-${expiry}`;
};
